export const laboratoryAr = {
 "Docteur": "الدكتور",
 "Patient": "المريض",
 "Prix du lab": "سعر المختبر",
 "Comptes": "الحسابات",
 "Consommations": "الاستهلاك",
 "Date D'empreinte": "تاريخ البصمة",
 "Date RDV": "تاريخ الموعد",
 "Patient Non Terminer": "المرضى غير مكتملين",
 "Comment": "تعليق",
 "Prix": "السعر",

  // Server side 

  "Le laboratoire deja existe.": "المختبر موجود بالفعل.",
  "Le nom du laboratoire est obligatoire !!": "إسم المختبر إجباري !!",
  "Le docteur est obligatoire": "الطبيب إلزامي",
  "Le montant est obligatoire": "المبلغ إلزامي",
  "le traitement deja existe": "العلاج موجود بالفعل",
  "Donner le traitement": "إعطاء العلاج",
  "Donner le prix": "أعط السعر",
  "Paiements Labo" : "دفعات المختبر", 



}